import { render, staticRenderFns } from "./SelectLangModal.vue?vue&type=template&id=1842dfe3&scoped=true&"
import script from "./SelectLangModal.vue?vue&type=script&lang=js&"
export * from "./SelectLangModal.vue?vue&type=script&lang=js&"
import style0 from "./SelectLangModal.vue?vue&type=style&index=0&id=1842dfe3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1842dfe3",
  null
  
)

export default component.exports